/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для формы юридических лиц
   */
  app.LegalEntityFormView = app.View.extend({
    el: '#legal-entity-form',
    formName: 'legal-entity',
    model: null,
    events: {
      'click #cancel': 'cancel',
      'click #save-legal-entity': 'save'
    },

    run: function (options) {
      this.owner = options.owner;
      this.$fields = this.$el.find('.field');
      new app.SettlementAutocompleteView({
        el: $('#settlement'),
        settlement: this.settlement,
      });
      new app.ChoiceOwnershipTypeView();

    },

    render: function (id) {
      var self = this,
        valRegion = '',
        valVillage = '',
        value;

      if (id) {
        this.model = this.owner.legalEntities.get(id);
        this.$fields.each(function () {
          value = self.model.get(this.name);
          if (value) {

            if (value.region) {
              valRegion = ' (' + value.region + ')';
            }
            if (value.type === 'village') {
              valVillage = 'д. ';
            }
            if ($(this).is('select')) {
              $(this).find('option[value=' + value + ']').attr('selected', 'selected');
            } else if (this.name === 'settlement') {
              $(this).val(valVillage + value.name + valRegion);
              $(this).data('settlement-id', value.id);
            } else {
              $(this).val(value);
              if (this.type === 'hidden') {
                $(this).trigger('change');
              }
            }
          }
        });
      } else {
        this.reset();
        if (app.user.attributes.name) {
          this.$('#contact_person').val(app.user.attributes.name);
        }
      }
      this.clearErrors();

      this.toggle();
    },

    cancel: function () {
      this.success();
    },

    save: function () {
      var attributes = {};
      this.$fields.each(function () {
        if (this.name === 'settlement') {
          attributes.settlement_id = $(this).data('settlement-id');
        } else {
          attributes[this.name] = $(this).val();
        }
      });
      if (this.model) {
        this.model.save(attributes, {'success': this.success.bind(this), 'error': this.error.bind(this)});
      } else {
        this.owner.legalEntities.create(attributes, {
          success: this.success.bind(this),
          error: this.error.bind(this),
          wait: true,
        });
        this.$('#save-legal-entity').prop('disabled', true);
      }
    },

    reset: function () {
      this.$('#save-legal-entity').prop('disabled', false);
      this.$fields.each(function () {
        if ($(this).is('select')) {
          $(this).find('option[value=1]').attr('selected', 'selected');
        } else if (this.type === 'hidden') {
          $(this).val(1);
          $(this).trigger('change');
        } else {
          $(this).val('');
        }
      });
      this.model = null;
    },

    success: function () {
      this.toggle();
      this.reset();
      this.owner.toggle();
    },

    error: function (model, response) {
      this.$('#save-legal-entity').prop('disabled', false);
      var that = this;
      var errors = JSON.parse(response.responseText);

      this.clearErrors();

      errors.forEach(function (error) {
        $('#' + that.formName + '-' + error.field + '-error').text(error.message);
        if (error.field === 'settlement_id') {
          $('#settlement').addClass('error');
        } else {
          $('#' + error.field).addClass('error');
        }
      });
    },

    clearErrors: function () {
      this.$fields.each(function () {
        $(this).removeClass('error');
      });
      this.$el.find('.error-message').text('');
    },
  });
})(jQuery);

}.call(window));